angular.module('dnecom')
    .directive('timeInterval', function() {
        function formatInterval (value) {
            var viewValue = "";

            if (value) {
                if (value.days) {
                    viewValue += " " + value.days + " day" + (value.days > 1 ? "s" : "");
                }

                if (value.hours) {
                    viewValue += " " + value.hours + " hour" + (value.hours > 1 ? "s" : "");
                }

                if (value.minutes) {
                    viewValue += " " + value.minutes + " minute" + (value.minutes > 1 ? "s" : "");
                }
            }

            return viewValue;
        };

        return {
            require: 'ngModel',
            scope: {
                interval: '=ngModel'
            },
            restrict: 'A',
            replace: true,
            link: function(scope) {
                scope.viewValue = formatInterval(scope.interval);
            },
            template: '<span>{{viewValue}}</span>',
        };
    });
